var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddedcontacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    rx: 17,
    fill: "#0BA9E0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1564 7H11.8224C11.3155 7 10.8294 7.20136 10.471 7.55978C10.1126 7.9182 9.9112 8.40432 9.9112 8.9112V11.778H8V13.6892H9.9112V15.6004H8V17.5116H9.9112V19.4228H8V21.334H9.9112V24.2008C9.9112 24.7077 10.1126 25.1938 10.471 25.5522C10.8294 25.9106 11.3155 26.112 11.8224 26.112H26.1564C26.4098 26.112 26.6529 26.0113 26.8321 25.8321C27.0113 25.6529 27.112 25.4098 27.112 25.1564V7.9556C27.112 7.70216 27.0113 7.4591 26.8321 7.27989C26.6529 7.10068 26.4098 7 26.1564 7ZM18.5116 9.86584C20.0864 9.86584 21.3784 11.1569 21.3784 12.7326C21.3756 13.4922 21.0727 14.2199 20.5357 14.7571C19.9987 15.2942 19.2711 15.5974 18.5116 15.6004C16.9377 15.6004 15.6448 14.3075 15.6448 12.7326C15.6448 11.1569 16.9377 9.86584 18.5116 9.86584ZM24.2452 22.2896H12.778V21.5729C12.778 19.4524 15.3629 17.2727 18.5116 17.2727C21.6603 17.2727 24.2452 19.4524 24.2452 21.5729V22.2896Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddedcontacts);
export default __webpack_public_path__ + "static/media/addedcontacts.20a98ab8988edbcd003ef18bfe02e09a.svg";
export { ForwardRef as ReactComponent };